import { CompleteBankAccountRequestDto, Loader, generateFlinksIframeUrl, reportErrorToConsole, useCompleteApplicantFlinks, useGetCreditApplicationById } from '@applyonline/shared'
import { EFinancingProgram, EFlinksEventSteps } from '@if/core/types'
import { getEnvRuntimeVariable } from '@if/core/utils'
import { useEffect, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { applicantFlinksId } from '../../data/creditapp-selectors'

const FlinksIncomeValidationPage = (): JSX.Element => {
  const { t, i18n } = useTranslation()
  const params = useParams()
  const [searchParams] = useSearchParams()
  const institutionShortName = searchParams.get('institutionShortName') ?? undefined
  const navigate = useNavigate()
  const id = params.id!
  const [completeFlinks, isCompletingFlinks] = useCompleteApplicantFlinks(EFinancingProgram.B2c)
  const [creditApp, isLoadingApp] = useGetCreditApplicationById(id, EFinancingProgram.B2c, false)
  const externalServiceId = applicantFlinksId(creditApp)

  useEffect(() => {
    window.addEventListener('message', (e: MessageEvent<{ step?: EFlinksEventSteps }>) => {
      if (e.data?.step) {
        // The request is done, we are receiving the answer
        if (e.data.step === EFlinksEventSteps.REDIRECT) {
          const completeFlinksDto = {
            id,
            externalServiceId,
          } as CompleteBankAccountRequestDto

          completeFlinks(completeFlinksDto).catch(reportErrorToConsole)

          navigate(`/creditapplication/${id}/flinks/status`, { replace: true })
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoadingApp) return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />

  const iframeUrl = generateFlinksIframeUrl({
    baseUrl: import.meta.env.VITE_FLINKS_IFRAME,
    customerName: 'iFinance',
    isDemoMode: getEnvRuntimeVariable<boolean>(import.meta.env.VITE_USE_DEMO_FLINKS),
    envTag: import.meta.env.VITE_ENV,
    externalServiceId,
    language: i18n.language,
    cleanWhitespace: true,
    institutionShortName
  })

  if (isCompletingFlinks) return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />
  return <iframe title="flinksIFrame" loading="eager" src={iframeUrl} className="full-page-iframe" />
}

export default FlinksIncomeValidationPage
